// extracted by mini-css-extract-plugin
module.exports = {"infoBlock":"style_infoBlock__l_Edx"};